<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-4">
      <h2>Processo - Questão</h2>
      <h3>Admin</h3>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content box-content">
            <div class="info-page">
              <h3>{{ actionLabel }} </h3>
            </div>
  
            <form [formGroup]="form" (ngSubmit)="salvar()">
              <div class="form-group row m-b">
                <div class="col-sm-8">
                  <label class="col-sm-12 pb-1">Título<sup class="text-danger ms-2">*</sup></label>
                  <input type="text" id="title" class="form-control" formControlName="title"  />
                  <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
                </div>
              </div>
              <div class="form-group row m-b">
                <div class="col-sm-8">
                  <label class="col-sm-12 pb-1">Máscara</label>
                  <input type="text" id="report_title" class="form-control" formControlName="report_title"  />
                  <app-field-message [field]="fieldMessageRequired('report_title')" [erros]="fieldErros('report_title')"></app-field-message>
                </div>
              </div>
              <div class="form-group row m-b">
                <div class="col-sm-8">
                  <label class="col-sm-12 pb-1">Dica</label>
                  <textarea id="tooltip" class="form-control" rows="3" formControlName="tooltip"></textarea>
                  <app-field-message [field]="fieldMessageRequired('tooltip')" [erros]="fieldErros('tooltip')"></app-field-message>
                </div>
              </div>
              <div class="form-group row m-b">
                <div class="col-sm-8">
                  <label class="col-sm-12 pb-1">Link</label>
                  <input type="text" id="ref_link" class="form-control" formControlName="ref_link"  />
                  <app-field-message [field]="fieldMessageRequired('ref_link')" [erros]="fieldErros('ref_link')"></app-field-message>
                </div>
              </div>
              <div class="form-group row m-b">
                <div  class="col-sm-6">
                    <label class="col-sm-12 pb-1">Tipo</label>
                    <ng-select 
                      id="type_id" 
                      class="ng-select-alternative" 
                      [items]="typeList" 
                      bindLabel="label" 
                      bindValue="id" 
                      placeholder="" 
                      formControlName="type_id" 
                      (change)="changeTypeId($event)"
                      [readonly]="isReadOnly"
                      >
                    </ng-select>
                   
                    <app-field-message [field]="fieldMessageRequired('type_id')" [erros]="fieldErros('type_id')"></app-field-message>
                </div>
              </div>
              <div *ngIf="form.get('type_id').value==1 || form.get('type_id').value==5" class="form-group row m-b">
                <div class="col-sm-4">
                    <label class="col-sm-12 pb-1">Tamanho</label>
                    <input type="number" id="max_length" class="form-control" formControlName="max_length" />
                    <app-field-message [field]="fieldMessageRequired('max_length')" [erros]="fieldErros('max_length')"></app-field-message>
                </div>
              </div>
              <div *ngIf="form.get('type_id').value==5">
                <div formArrayName="items">
                  <div *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
                    <div class="form-group row m-b">
                      <div class="col-sm-4">
                        <label class="col-sm-12 pb-1">Opção combo</label>
                        <input 
                             type="text" id="item" 
                             class="form-control" 
                             formControlName="ds_value" 
                             [readOnly]="item.get('isUsed').value"
                             [ngClass]="{'readonly-input': item.get('isUsed').value}"/>
                        <!-- 
                         <app-field-message [field]="fieldMessageRequireds('irfe_type', i)" [erros]="fieldErrosFormArray('irfe_type', i)"></app-field-message>
                       -->
                      </div>
                      <button class="btn btn-danger col-sm-1 btn-remove" type="button" (click)="removeCombo(i)" [disabled]="item.get('isUsed').value"><i
                          class="fa fas fa-times"></i></button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success btn-add-item m-b" type="button" (click)="addNewCombo()">Novo Item</button>
              </div>
              <div *ngIf="form.get('type_id').value==4" class="form-group row m-b">
                <div class="col-sm-8">
                    <label class="col-sm-12 pb-1">Casas Decimais</label>
                    <ng-select id="type_id" class="ng-select-alternative" [items]="decPlacesList" bindLabel="label" bindValue="id" placeholder="" formControlName="dec_places">
                    </ng-select>
                    <app-field-message [field]="fieldMessageRequired('dec_places')" [erros]="fieldErros('dec_places')"></app-field-message>
                </div>
              </div>
              <div class="form-group row m-b">
                <div class="col-sm-8">
                    <label class="col-sm-12 pb-1">Ativo</label>
                    <ng-select id="type_id" class="ng-select-alternative" [items]="activeList" bindLabel="label" bindValue="id" placeholder="" formControlName="actived">
                    </ng-select>
                    <app-field-message [field]="fieldMessageRequired('actived')" [erros]="fieldErros('actived')"></app-field-message>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group row d-flex justify-content-end">
                <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                  <button class="btn btn-danger m-r-xxl" *ngIf="this.entity?.id" (click)="confirmExcluir()"
                    type="button">Excluir</button>
                  <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                  <button class="btn btn-primary" type="submit">Salvar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loading [loader]="isLoading"></app-loading>